import styled from 'styled-components';

export const ClientList = styled.div`
  .message-success {
    font-family: Poppins, Heltica, Arial, sans-serif;
    background-color: #26D519;  
    font-size: 3em;
    margin: 35px 50px 0;
    padding: 10px 0;
    text-align: center;
    color: #ffffff;
    border-radius: 3px;
  }  
`;
